import a, { forwardRef as o } from "react";
import { Switch as r, useTheme as m, FormControlLabel as b, Stack as d, Typography as c } from "@mui/material";
import { g as h } from "./chunk.BurCwd5X.js";
const i = o(
  (e, t) => /* @__PURE__ */ a.createElement(
    r,
    {
      id: e.id,
      disabled: e.disabled,
      checked: e.checked,
      onChange: (l, u) => {
        var n;
        return (n = e.onChange) == null ? void 0 : n.call(e, l, u);
      },
      inputProps: { "aria-label": e.ariaLabel },
      disableRipple: !0,
      ref: t,
      onBlur: e.onBlur,
      onFocus: e.onFocus,
      onMouseOver: e.onMouseOver,
      onMouseLeave: e.onMouseLeave,
      ...h(t)
    }
  )
), s = (e, t) => /* @__PURE__ */ a.createElement(d, null, /* @__PURE__ */ a.createElement(c, null, e.label), e.subText && /* @__PURE__ */ a.createElement(
  c,
  {
    variant: "body2",
    color: e.disabled ? void 0 : t
  },
  e.subText
)), v = o(
  (e, t) => {
    const l = m();
    return e.label ? /* @__PURE__ */ a.createElement(
      b,
      {
        control: /* @__PURE__ */ a.createElement(i, { ...e, ref: t }),
        label: s(e, l.palette.grey[800]),
        sx: { justifyContent: "space-between", display: "flex" },
        labelPlacement: "start"
      }
    ) : /* @__PURE__ */ a.createElement(i, { ...e, ref: t });
  }
);
export {
  v as S
};
